import React, { useEffect, useState } from 'react'
import { Col, Input, Row, FormGroup, Alert } from 'reactstrap'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import Switch from 'react-switch'
import { useFormUtils } from 'views/shared/useFormUtils'
import PropTypes from 'prop-types'
import { isNotNumericDecimal } from 'context/Utilities'

const PlantCheeseNutritionReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    Calcium: item.Calcium,
    CalciumCertification: item.CalciumCertification,
    Protein: item.Protein,
    ProteinCertification: item.ProteinCertification,
  })

  const methods = useFormContext()
  const { setSwitchReviewer, onChangeReviewer, asterisk } = useFormUtils()

  useEffect(() => {
    if (item !== null) {
      const {
        Calcium,
        CalciumCertification,
        Protein,
        ProteinCertification,
      } = item
      setPackaging({
        Calcium,
        CalciumCertification,
        Protein,
        ProteinCertification,
      })
    }
    // eslint-disable-next-line
  }, [item])

  return (
    <>
      <Row>
        <Col xs={6}>
          <FormGroup>
            <p>
              <strong>Calcium (mg) per 8 ounces {asterisk}</strong>
            </p>
            <Controller
              as={Input}
              name="Calcium"
              type="number"
              step="0.01"
              placeholder="Min 250mg calcium per 8 ounces"
              defaultValue={packaging.Calcium}
              onKeyDown={e => {
                if (isNotNumericDecimal(e.key)) {
                  e.preventDefault()
                }
              }}
              control={methods.control}
              rules={{
                maxLength: {
                  value: 6,
                  message: '⚠ Calcium (mg) per 8 ounces exceeds 6 characters',
                },
                min: {
                  value: 250,
                  message:
                    '⚠ Calcium (mg) per 8 ounces is below the required 250mg minimum',
                },
                required: {
                  value: true,
                  message: '⚠ Please enter Calcium (mg) per 8 ounces',
                },
                pattern: {
                  value: /^\d+(\.\d{1,2})?$/,
                  message: '⚠ Maximum two decimal places allowed.',
                },
              }}
              onChange={([event]) => {
                onChangeReviewer(item, event)
                return event
              }}
              disabled={isDisabled}
            />
            <ErrorMessage
              errors={methods.errors}
              name="Calcium"
              as={<Alert color="danger" className="mt-3" />}
            />
          </FormGroup>
        </Col>
        <Col xs={6}>
          <FormGroup>
            <p>
              <strong>
                I certify that this product contains at least 250mg calcium per
                8 ounces. {asterisk}
              </strong>
            </p>
            <Controller
              as={Switch}
              name="CalciumCertification"
              id="CalciumCertification"
              defaultValue={packaging.CalciumCertification}
              onChange={([checked, event, id]) => {
                setSwitchReviewer(item, checked, event, id)
                return checked
              }}
              control={methods.control}
              rules={{ validate: value => value === true }}
              disabled={isDisabled}
            />
            <ErrorMessage
              errors={methods.errors}
              name="CalciumCertification"
              message={
                '⚠ You must certify that this product contains no less than the required minimum 250mg total calcium per 8 ounces.'
              }
              as={<Alert color="danger" className="mt-3" />}
            />
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col xs={6}>
          <FormGroup>
            <p>
              <strong>Protein (g) per 8 ounces {asterisk}</strong>
            </p>
            <Controller
              as={Input}
              name="Protein"
              type="number"
              step="0.01"
              placeholder="Min 6.5g protein per 8 ounces"
              defaultValue={packaging.Protein}
              onKeyDown={e => {
                if (isNotNumericDecimal(e.key)) {
                  e.preventDefault()
                }
              }}
              control={methods.control}
              rules={{
                maxLength: {
                  value: 4,
                  message: '⚠ Protein (g) per 8 ounces exceeds 4 characters',
                },
                min: {
                  value: 6.5,
                  message:
                    '⚠ Protein (g) per 8 ounces is below the required 6.5g minimum',
                },
                required: {
                  value: true,
                  message: '⚠ Please enter Protein (g) per 8 ounces',
                },
                pattern: {
                  value: /^\d+(\.\d{1,2})?$/,
                  message: '⚠ Maximum two decimal places allowed.',
                },
              }}
              onChange={([event]) => {
                onChangeReviewer(item, event)
                return event
              }}
              disabled={isDisabled}
            />
            <ErrorMessage
              errors={methods.errors}
              name="Protein"
              as={<Alert color="danger" className="mt-3" />}
            />
          </FormGroup>
        </Col>
        <Col xs={6}>
          <FormGroup>
            <p>
              <strong>
                I certify that this product contains at least 6.5g protein per 8
                ounces. {asterisk}
              </strong>
            </p>
            <Controller
              as={Switch}
              name="ProteinCertification"
              id="ProteinCertification"
              defaultValue={packaging.ProteinCertification}
              onChange={([checked, event, id]) => {
                setSwitchReviewer(item, checked, event, id)
                return checked
              }}
              control={methods.control}
              rules={{ validate: value => value === true }}
              disabled={isDisabled}
            />
            <ErrorMessage
              errors={methods.errors}
              name="ProteinCertification"
              message={
                '⚠ You must certify that this product contains no less than the required minimum 6.5g total protein per 8 ounces.'
              }
              as={<Alert color="danger" className="mt-3" />}
            />
          </FormGroup>
        </Col>
      </Row>
    </>
  )
}

PlantCheeseNutritionReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default PlantCheeseNutritionReview
